import { Fragment, useMemo } from 'react';
import type React from 'react';

import { CardList } from '@change-corgi/design-system-legacy/layout';

import { PromotedImpressionTracker } from 'src/app/shared/components/promotionTracking';

import type { VictoriousPetition } from '../../../../shared/api';
import { PetitionCardViewTracker } from '../../../../shared/components/viewTracking';
import type { SuggestedPetitionSourceLocation } from '../../../../shared/types';

import { VictoriousPetitionCard } from './components/VictoriousPetitionCard';

type Props = Readonly<{
	petitions: readonly VictoriousPetition[];
	parentPetitionId?: string;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export const VictoriousPetitionsList: React.FC<Props> = ({ petitions, parentPetitionId, sourceLocation }) => {
	const displayCount = 4;
	const displayedPetitions = useMemo(() => petitions.slice(0, displayCount), [petitions, displayCount]);

	return (
		<CardList
			data-qa="suggested-victorious-petitions"
			itemsPerRow={[1, 2, 3, 4]}
			itemWidth="dynamic"
			itemSpacing={['small', 'default']}
			maxListWidth={[400, 'none']}
		>
			{displayedPetitions.map((petition, index) => (
				<Fragment key={petition.node.id}>
					{petition.promotionToken && (
						<PromotedImpressionTracker
							petitionId={petition.node.id}
							promotionToken={petition.promotionToken}
							placement={sourceLocation}
							victory
							algorithm="victories"
						/>
					)}
					<PetitionCardViewTracker
						petitionId={petition.node.id}
						petitionStatus="victorious"
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						algorithm="victories"
						strategy="victories"
					/>
					<VictoriousPetitionCard
						petition={petition}
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						sourceLocation={sourceLocation}
					/>
				</Fragment>
			))}
		</CardList>
	);
};
